import * as Sentry from "@sentry/react";
import type { Middleware } from "openapi-fetch";

import { UNKNOWN_ERROR_CODE } from "../errors/ApiError";
import { parseApiError } from "../errors/parseApiError";

// Ответ не из 2xx → бросаем `ApiError`. Поэтому `{ error }` из openapi-fetch не используется:
// хуки `$api` получают ошибку с `status`, `code` и `params`, а не голое тело.
// Код не из контракта уходит в Sentry (без `VITE_SENTRY_DSN` вызов ничего не делает).
export const errorsMiddleware: Middleware = {
  async onResponse({ request, response, schemaPath }) {
    if (response.ok) {
      return undefined;
    }
    const error = await parseApiError(response);
    if (error.code === UNKNOWN_ERROR_CODE) {
      Sentry.captureMessage("Unknown API error code", {
        level: "warning",
        tags: { api_status: error.status, api_error: error.rawCode ?? "none" },
        extra: { method: request.method, path: schemaPath },
        fingerprint: ["api-unknown-error", String(error.status), error.rawCode ?? "none"],
      });
    }
    throw error;
  },
};
